export default __webpack_public_path__ + "static/media/new7.926b5f6f.png";